import React, { useEffect, useState } from "react";
import useForm, { Form } from "../../../../../hooks/useForm";
import Controls from "../../../../../components/form/controls/Controls";
import { validationReleaseOSInput } from "../../../utils/validateInput";
import { isDisableSubmit } from "../../../utils";

const initialValue = {
  id: "",
  operatingSystem: "",
  name: "",
};

function ReleaseOSForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateFLFReleaseOSForm = (fieldValues = values) => {
    let temp = validationReleaseOSInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFReleaseOSForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFReleaseOSForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />

      <Controls.Input
        name="operatingSystem"
        value={values.operatingSystem}
        label="operatingSystem"
        type="text"
        onChange={handleOnChange}
        error={errors.operatingSystem}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default ReleaseOSForm;
